import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { getCurrentUser } from './Utils';

const ProtectedRoute = ({ path, viewComponent: ViewComponent }) => {
  const currentUser = getCurrentUser();
  // console.log(getCurrentUser());
  

  return currentUser ? (
    <Route exact path={path} render={(props) => <ViewComponent {...props} />}/>

  ) : (
    <Redirect to= "/" />
  );
};

export default ProtectedRoute; 

